import { Injectable, inject } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';

/**
 * Service to work with browser viewports
 */
@Injectable({
  providedIn: 'root'
})
export class ViewPortService {
  private media = inject(MediaMatcher);

  isMobile: boolean;
  isDesktop: boolean;

  constructor() {
    const mediaQueryList: MediaQueryList = this.media.matchMedia('(max-width: 767px)');
    const desktopMediaQueryList: MediaQueryList = this.media.matchMedia('(min-width: 1200px)');
    this.isMobile = mediaQueryList.matches;
    this.isDesktop = desktopMediaQueryList.matches;
    mediaQueryList.addEventListener('change', () => this.isMobile = mediaQueryList.matches);
    desktopMediaQueryList.addEventListener('change', () => this.isDesktop = desktopMediaQueryList.matches);
  }

  get viewport(): 'mobile' | 'tablet' | 'desktop' {
    if (this.isMobile) {
      return 'mobile';
    }

    if (this.isDesktop) {
      return 'desktop';
    }

    return 'tablet';
  }
}
